enum PlayerIbansRejectStatusType {
  WRONG_DOCUMENT = 'WRONG_DOCUMENT',
  NOT_SAME_PERSON = 'NOT_SAME_PERSON',
  IMAGE_QUALITY_TOO_LOW = 'IMAGE_QUALITY_TOO_LOW',
  DOCUMENT_TOO_OLD = 'DOCUMENT_TOO_OLD',
}

export default PlayerIbansRejectStatusType
